import React, { useState, useEffect, useRef } from "react";
import { QrReader } from "react-qr-reader";
import { apiCallPost } from "./fns/util";
import {
  ACTION_ITEM_FOOD,
  ACTION_ITEM_KIT,
  MEAL_TIMESTAMP,
} from "./seminar_service/SeminarServiceConfig";
import { Button } from "antd";
import { Select } from "antd";
import _ from "lodash";

const { Option } = Select;

class BadgeScan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionMode: "KIT",
      optionMode2: "For Breakfast on 15th December, 2023",
      errorText: "",
      currentQrCode: null,
      currentDelegate: null,
    };
  }

  getDelegateInfo = async (delegate_id) => {
    try {
      const res = await apiCallPost(
        "jhgjh",
        "/conference2023/getDelegateById",
        {
          delegateId: delegate_id,
        }
      );
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  doKitHandover = async (delegate_id) => {
    try {
      const res = await apiCallPost("jhgjh", "/conference2023/setKitHandover", {
        delegateId: delegate_id,
      });
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  doConfirmMeal = async (delegate_id) => {
    try {
      const res = await apiCallPost(
        "jhgjh",
        "/conference2023/confirmMealAccess",
        {
          delegateId: delegate_id,
          mealSpec: this.state.optionMode2,
        }
      );
      return res;
    } catch (error) {
      console.log(error);
    }
  };

  isDelegateEligibleForMeal = (delegate, mealSpec) => {
    const GODS = [
      "rupakkbiswas@gmail.com",
      "sugato100@gmail.com",
      "docrpg_2000@yahoo.com",
      "rajeshmchaudhuri@hotmail.com",
    ];

    if (GODS.includes(delegate.email)) return true;

    const hasAccess0 = _.find(
      delegate.lineItems,
      (li) => li.item === "Complete package"
    );
    const hasAccess1 = _.find(delegate.lineItems, (li) => li.item === mealSpec);
    const hasAccess = hasAccess0 || hasAccess1;
    console.log({ hasAccess, hasAccess0, hasAccess1 });
    if (!hasAccess) return false;
    const hasConfirmed = _.find(
      delegate.mealSpecs || [],
      (ms) => ms === mealSpec
    );
    console.log({ hasConfirmed });
    if (hasConfirmed) return false;
    return true;
  };

  handleOptionChange(key, v) {
    this.setState({
      [key]: v,
      currentQrCode: null,
      currentDelegate: null,
    });
  }

  async handleTrigger(delegateId) {
    const delegate = await this.getDelegateInfo(delegateId);
    if (this.state.optionMode === "KIT") {
      if (delegate.delegate.isRegistered === false) {
        this.setState({
          errorText: "Delegate not registered",
          currentQrCode: delegateId,
          currentDelegate: delegate.delegate,
        });
        return;
      }
      if (delegate.delegate.kitHandover) {
        this.setState({
          errorText: "Kit already handed over",
          currentQrCode: delegateId,
          currentDelegate: delegate.delegate,
        });
      } else {
        const res = await this.doKitHandover(delegateId);
        this.setState({
          errorText: "Do the Kit hand over - NOW",
          currentQrCode: delegateId,
          currentDelegate: res.delegate,
        });
      }
    } else if (this.state.optionMode === "FOOD") {
      if (delegate.delegate.isRegistered === false) {
        this.setState({
          errorText: "Delegate not registered -- contact regn desk",
          currentQrCode: delegateId,
          currentDelegate: delegate.delegate,
        });
        return;
      }
      if (
        this.isDelegateEligibleForMeal(
          delegate.delegate,
          this.state.optionMode2
        )
      ) {
        const res = await this.doConfirmMeal(delegateId);
        this.setState({
          errorText: "Meal confirmed.",
          currentQrCode: delegateId,
          currentDelegate: res.delegate,
        });
      } else {
        this.setState({
          errorText: "Meal not confirmed.",
          currentQrCode: delegateId,
          currentDelegate: delegate.delegate,
        });
      }
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Select
          value={this.state.optionMode}
          style={{ width: "80vw", alignSelf: "center" }}
          onChange={(v) => this.handleOptionChange("optionMode", v)}
        >
          <Option value={ACTION_ITEM_KIT}>{ACTION_ITEM_KIT}</Option>
          <Option value={ACTION_ITEM_FOOD}>{ACTION_ITEM_FOOD}</Option>
        </Select>
        {this.state.optionMode === "FOOD" ? (
          <Select
            value={this.state.optionMode2}
            style={{ width: "80vw", alignSelf: "center" }}
            onChange={(v) => this.handleOptionChange("optionMode2", v)}
          >
            {MEAL_TIMESTAMP.map((timestamp) => (
              <Option value={timestamp}>{timestamp}</Option>
            ))}
          </Select>
        ) : null}
        <QrReader
          constraints={{ facingMode: "environment" }}
          onResult={async (result, error) => {
            if (result) {
              console.log(result);
              const delegateId = _.last(_.split(result, "/"));
              if (this.state.currentDelegate?._id !== delegateId) {
                console.log("TRIGGER", this.state.delegateId, delegateId);
                await this.handleTrigger(delegateId);
              } else {
              }
            } else {
            }
          }}
          style={{ width: "100%" }}
        />
        {this.state.currentDelegate ? (
          <div>
            {this.state.currentDelegate.name} |{" "}
            {this.state.currentDelegate.email} |{" "}
            {this.state.currentDelegate.mobile} | <br />
            LineItems:{" "}
            {_.join(
              this.state.currentDelegate.lineItems.map((li) => li.item),
              ", "
            )}{" "}
            | <br />
            Meals Done:{" "}
            {_.join(this.state.currentDelegate.mealSpecs || [], ", ")} | <br />
          </div>
        ) : (
          <div>No Delegate Loaded </div>
        )}
        {this.state.errorText ? (
          <div style={{ color: "red" }}>{this.state.errorText}</div>
        ) : null}
      </div>
    );
  }
}

export default BadgeScan;
